import { styled } from "styled-components";


export const NewAPVStyle = styled.section`
margin-left: 3vw;
margin-right: 4vw; 
text-align: center;


#toTop{
position: fixed;
width: fit-content;
height: 6vh;
bottom: 20px;
right: 0;
background-color: rgba(0,0,0,0);
border: none;
font-size: 25px;
}
#modalBtn{
    position: absolute;
    top: 0px;
    right: 30px;
    height: 5vh;
    width: 8vw;
    font-size: 30px;
    font-weight: bold;
    
}

.modal{
    position: fixed;
    left: 1.4vw;
    top: 18rem;
    background-color: white;
    border: solid black 1px;
    height: auto;
    width: 9rem;
    z-index: 2;
    border: none;
    .modal-content{
        background-color: #007297;
        line-height: 2rem;
        color: white;
        font-weight: bold;
        height: 19rem;
        width: auto;
        overflow-y: scroll;
        overflow-x: hidden;
        scrollbar-width: none;
        font-size: 15px;
        p{
            border-bottom: white 2px solid;
            
        }

    }
}



button{
    display: block;
    text-align: center;
    width: 90%;
    margin-left: 4vw;
    border-radius: 6px;
    height: 6vh;
    font-size: 17px;
    border: solid black 1px;
    margin-bottom: 1vh;
}
.mobileForm{

    
    div{
        background-color: #007297;
        border-radius: 6px;
        padding-bottom: 2vh;
        padding-top: 2vh;
        margin-bottom: 2vh;
        p{
            margin-bottom: 2vh;
            font-size: 17px;
            font-weight: bold;
        }
    }
    
    h2{
        border-bottom: solid black;
        margin-bottom: 4vh;
        margin-top: 6vh;
    }
    
    
    input{
        width: 90%;
        height: 4vh;
        margin-bottom: 2vh;
        font-size: 17px;
    }
}

.btnDiv{
    grid-template-columns: 1fr 1fr;
    width: 1rem;
    gap: 0.3rem;
    position: fixed;
        left: 1.9vw;
        top: 60vh;
        z-index: 1;
    button{
        width: 4rem;
        height: 4rem;
        margin: 0;
        border: none;
        img{
            height: 3rem;
            width: 3rem;
        }
    }
}
.btnDiv2{
    #toTop{

    }
    #modalBtn{
        z-index: 2;
        background-color: #007297;
        color: white;
        position: fixed;
        margin: 0;
        left: 3.5vw;
        top: 14rem;
        border: none;
        width: fit-content;
        font-weight: bold;
        font-size: 25px;
    }
}
.desktopForm{
    width: 80vw;
    margin-left: 10rem;
    margin-bottom: 10rem;
    h3{
        font-size: 30px;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }

.overheadingDiv{        
    display: flex;
        justify-content: center;
        h2{
        margin: 2vh 0vw 2vh 0vw;
        border-bottom: solid black 1px;
        width: fit-content;

    }
}

    .categoryDiv{
    display: grid;
    grid-template-columns: 50% 7% 7% 7% 29%;
    p{
        padding-top: 0.5vh;
    }
}

.headingArt{
        display: grid;
        grid-template-columns: 10% 40% 7% 7% 7% 29%;
        border: solid 1px black;
        border-top: none;

        div{
            padding: 1vh 1vw;
            
        }
            textarea{
        field-sizing: content;
            width: 90%;
            height: max-content;
            padding: 1vh 1vw;
            border: none;
            font-size: 16px;   
        }
        span{
            display: flex;
            justify-content: space-between;
            
                   p{
                    
            height: fit-content;
            text-align: left;
            
        } 


        }
        input{
            width: 100%;
            height: 5vh;
            border: none;
            border-bottom: solid black 1px;
            font-size: 23px;
        }
}
.handleplanArt{
    display: grid;
    grid-template-columns: 30% 30% 20% 20%;
    border: solid 1px black;
    border-top: none;
            textarea{
        field-sizing: content;
            width: 116px;
            height: max-content;
            padding: 1vh 1vw;
            border: none;
            
            
        }
    div{
         
        border-right: solid black 1px; 
    }
    span{
        display: flex;
        justify-content: space-between;
               p{
        height: 5vh;
    } 

    }
    input{
        width: 100%;
        height: 4vh;
        margin-top: 4vh;
        width: 12vw;
        border: none;
        border-bottom: solid black 1px;
        font-size: 23px;
    }

    button{
        width: 11.5vw;
        height: 7vh;
        margin-top: 1vh;
    }
    .deadlineInputDiv{    
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
        label{
            padding-top: 4vh;
        width: 10vw;
    }
    input:first-of-type{  
        height: 2vh;
        margin-top: 4vh;
    }
    input:last-of-type{  
        height: 3vh;
        margin-top: 4vh;
        width: 10vw;
    }
}

}
.newQuestion{
    margin: 0;
    height: 5vh;
    width: 100%;
}

#newQuestionArt{
    padding-top: 10px;
display: grid;
grid-template-columns: 5% 75% 10%;
    button:first-of-type{
        background-color: #28C253;
    }
    button:last-of-type{
        background-color: #CF4040;
    }
    input{
        padding-top: 15px;
        width: 100%;
    }
    
}
}

@media screen and (max-width: 768px) {
    margin: 0;
    .btnDiv{
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    width: 1rem;
    gap: 0.3rem;
    position: fixed;
        left: 3vw;
        top: 90vh;
        bottom: 0;
        z-index: 1;
    button{
        width: 3rem;
        height: 3rem;
        margin: 0;
        border: none;
        img{
            height: 2rem;
        }
    }
}

.modal{
    position: fixed;
    left: 0rem;
    top: 0rem;
    background-color: white;
    border: solid black 1px;
    height: auto;
    width: 23.5rem;
    z-index: 2;
    border: none;
    .modal-content{
        border: solid black 1px;
        padding: 1rem;
        background-color: #007297;
        line-height: 2rem;
        color: white;
        font-weight: bold;
        height: 34rem;
        width: auto;
        overflow-y: scroll;
        overflow-x: hidden;
        scrollbar-width: none;
        font-size: 15px;
        p{
            border-bottom: white 2px solid;
            
        }

    }
}
}

`